import { Link, useLocation } from "react-router-dom";
import { twMerge } from "tailwind-merge";


// pattern example new RegExp("^/accounts$")
export type MenuProp = {
    path: string
    label: string
    pattern: RegExp
}

export type HorizontalMenuProps = {
    links: Array<MenuProp>;
    className?: string
}


const HorizontalMenu = (props: HorizontalMenuProps) => {
    const location = useLocation();

    return (
        <div className={twMerge(
            "max-w-max bg-[#F2F0ED] p-1 rounded-lg",
            props.className
        )}>
            <div className="flex text-sm w-full rounded-lg">
                {
                    props.links.map((item) =>
                        <Link
                            key={item.label}
                            to={item.path}
                            className={twMerge(
                                "cursor-pointer focus:outline-none font-medium",
                                "px-4 lg:px-8 py-1.5 rounded-lg transition-transform duration-300 ease-linear", 
                                item.pattern.test(location.pathname) ? 
                                "text-secondary bg-white" : 
                                "text-[#6B5C4F] hover:text-secondary"
                            )}>
                            {item.label}
                        </Link>
                    )
                }
            </div>
        </div>
    )
}

export default HorizontalMenu